import { configureAuthSession, requestHostTokenIfEligible } from "./auth_session";
import { ITrackingConfig } from "../interfaces/tracking_config";
import { store } from "../store/store";
import { startAdminModeRestore } from "./admin_mode";
import { Util } from "../util";
import { normalizeHoverBorders } from "./normalize_button_borders";
import { getQueryStringValue } from "./get_querystring_value";
import { ChatService } from "../service/chat_service";
import { __vueEvent } from "../constant";
import { EVENTS } from "../enums/events";
import { STORE_ACTION } from "../enums/store_action";
import { onExceptionOccured } from "./on_exception_occured";
import { IConfig } from "../interfaces/config";
import { STORE_MUTATION } from "../enums/store_mutation";
import { HttpRequest } from "./http_request";
import { ErrorHelper } from "./error_helper";
import { Errors } from "../enums/errors";
import { getAppUrl } from ".";
import { deleteCookie } from "./cookie_handler";
import { IPageConfig } from "../interfaces/page_config";
import { CONSTANTS, DEFAULT_TIME_FORMAT } from "../enums";
import { StorageHelper } from "../helpers";

//declare var SatisfiApp;
export class ConfigLoader {
	async load() {
		try {
			const service = new ChatService();
			let pageId = getQueryStringValue("pageID");
			let satisfiForceNewSession = getQueryStringValue("satisfiForceNewSession");
			let satisfiForceNewUser = getQueryStringValue("satisfiForceNewUser");
			let isHideTitleBar = getQueryStringValue("HideTitleBar");

			if (!Util.isNullOrEmpty(satisfiForceNewSession) && satisfiForceNewSession == "1") {
				try {
					try {
						const keepKey = "user_id";

						Object.keys(localStorage).forEach(key => {
							if (key !== keepKey) {
								localStorage.removeItem(key);
							}
						});
					} catch (ex) {
						var cookies = document.cookie.split(";");

						for (var i = 0; i < cookies.length; i++) {
							var cookie = cookies[i];
							var eqPos = cookie.indexOf("=");
							var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
							if (name.toLowerCase() === "user_id") {
									continue;
							}
							document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
						}
					}
				} catch (ex) {}
			}

			if (!Util.isNullOrEmpty(satisfiForceNewUser) && satisfiForceNewUser == "1") {
				try {
					try {
						localStorage.clear();
					} catch (ex) {
						var cookies = document.cookie.split(";");

						for (var i = 0; i < cookies.length; i++) {
							var cookie = cookies[i];
							var eqPos = cookie.indexOf("=");
							var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
							document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
						}
					}
				} catch (ex) {}
			}

			if (!Util.isNullOrEmpty(isHideTitleBar)) {
				store.commit(STORE_MUTATION.SetIsHideTitleBar, Number(isHideTitleBar) == 1);
			}
			if (Util.isNullOrEmpty(pageId)) {
				const err = new ErrorHelper(Errors.NoPageIdSupplied).errMessage;
				store.commit(STORE_MUTATION.SetErrorMessage, err);
				return;
			}
			store.commit(STORE_MUTATION.SetPageId, pageId);
			const configs: IConfig = await service.getPageConfig(pageId);

			//SD-6795: Pre-format the header image destination tracking URL
			const headerImageDestTrackingURL = this.getHeaderImageDestTrackingURL(configs, pageId);

			//Send header details to parent of Iframe
			if (store.state.isIFrameLoaded) {
				//Send details to show header
				window.parent.postMessage(
					{
						event_id: "onHeaderConfigLoaded",
						data: {
							headerImage: configs.headerImage,
							pageTitle: configs.pageTitle,
							hidePageTitle: configs.hidePageTitle,
							pageName: configs.pageName,
							headerThemeUrl: configs.headerThemeUrl,
							headerImageDestinationURL: configs.headerImageDestinationURL,
							headerImageTrackingConfig: configs.headerImageTrackingConfig,
							headerImageDestTrackingURL: headerImageDestTrackingURL,
							companyId: configs.companyId,
						},
					},
					"*"
				);
			}
			store.commit(STORE_MUTATION.SetSatisfiURL, configs.pageURL);
			store.commit(STORE_MUTATION.SetHeaderImage, configs.headerImage);
			store.commit(STORE_MUTATION.SetBackgroundImage, configs.backgroundImage);
			store.commit(STORE_MUTATION.SetHeaderImageDestinationURL, configs.headerImageDestinationURL);
			store.commit(STORE_MUTATION.SetHeaderImageDestTrackingURL, headerImageDestTrackingURL);

			// SD-3460: New settings for the Admin Login and MFA
			store.commit(STORE_MUTATION.SetWebApiAddress, configs.webApiAddress);
			store.commit(STORE_MUTATION.SetDashboardAddress, configs.dashboardAddress);
			store.commit(STORE_MUTATION.SetAttemptNoofInvalidCode, configs.attemptNoofInvalidCode);
			store.commit(STORE_MUTATION.SetAttemptNoofResendCode, configs.attemptNoofResendCode);
			store.commit(STORE_MUTATION.SetMFAExpiration, configs.mfaExpiration);
			store.commit(STORE_MUTATION.SetMFAEnableDateTime, configs.mfaEnableDateTime);
			store.commit(STORE_MUTATION.SetIsMFAEnabled, configs.mfaEnabled);

			// SD-13570: the freshness and refresh timings are server-configured
			// (appsettings AuthChat:*), so the page and the server enforce the
			// same numbers. Applied BEFORE the request below, because that is
			// the first thing that can start a refresh.
			configureAuthSession(configs);

			// SD-13570: only an authentication-enabled page asks its host for a
			// token. Off (every existing page) means no credential traffic at all.
			requestHostTokenIfEligible(!!configs.authenticationEnabled);

			// SD-3681: New store props for WebChat Consent Modal (Terms and Conditions)
			store.commit(STORE_MUTATION.SetIsTermsConsentEnabled, configs.enableTermsConsent);
			store.commit(STORE_MUTATION.SetTermsConsentPayload, configs.termsConsentPayload);
			store.commit(STORE_MUTATION.SetTermsConsentExpiration, configs.termsConsentExpiration);

			// Set all config values from the server
			store.commit(STORE_MUTATION.SetClientVersion, configs.clientVersion || "");
			store.commit(STORE_MUTATION.SetMinimumClientVersion, configs.minimumClientVersion || "");
			store.commit(STORE_MUTATION.SetBaseInlineActionUrl, configs.baseInlineActionUrl || "");
			store.commit(STORE_MUTATION.SetTaglineUrl, configs.taglineUrl || "");
			store.commit(STORE_MUTATION.SetSenderDisplayName, configs.senderDisplayName || "");
			store.commit(STORE_MUTATION.SetSenderLiveDisplayName, configs.senderLiveDisplayName || "");
			store.commit(STORE_MUTATION.SetThumbsDownResponse, (configs.thumbsDownResponse || ""));
			store.commit(STORE_MUTATION.SetThumbsupResponse, (configs.thumbsupResponse || ""));
			store.commit(STORE_MUTATION.SetFeedbackClickCooldownSeconds, configs.messageFeedbackClickCooldownSeconds || 0);
			store.commit(
        STORE_MUTATION.SetFeedbackDownButtonLabels,
        this.parseQuotedStringArray(configs.messageFeedbackDownButtonLabels)
      );

			store.commit(STORE_MUTATION.SkipWelcomeMessageOnURLInput, configs.skipWelcomeMessageOnURLInput);
			store.commit(STORE_MUTATION.SetPiiSensitivity, configs.piiSensitivity);
			store.commit(STORE_MUTATION.SetIOSInputFontFix, configs.iosInputFontFix ?? false);

			// If HideTitleBar was not passed from the querystring,
			// Check in the config if hidePageTitle is true
			if (Util.isNullOrEmpty(isHideTitleBar) && !!configs.hidePageTitle) {
				store.commit(STORE_MUTATION.SetIsHideTitleBar, !!configs.hidePageTitle);
			}

			//SD-6443: Update page config on chat page load
			this.updatePageConfig(configs);

			if (configs.errorMessage.length == 0) {
				await this.setTheme(configs);
				store.dispatch(STORE_ACTION.InitConfig, configs);
				this.startAdminModeRestoreIfEnabled(configs);
				if (document.title.length == 0) {
					document.title = configs.pageName;
				}
			} else {
				await this.setErrorTheme();
				console.log("error");
				const err = configs.errorMessage;
				store.commit(STORE_MUTATION.SetErrorMessage, err);
			}
		} catch (ex) {
			store.commit(STORE_MUTATION.SetErrorMessage, "Unable to load page.");
			onExceptionOccured("getWelcomeMsg", ex);
		}
	}

	private async setErrorTheme() {
		const style = document.createElement("style");
		style.innerHTML = `\n:root{--chatFontFamily: 'Open Sans';
        --errorContainerBgColor: #f7f7f7;
        --chatWidth: 425px;
        --errorTextColor: #333;}`;
		style.id = "satisfi_theme";
		document.head.appendChild(style);
	}

	private async setTheme(config: IConfig) {
		const themeUrl = config.themeUrl;
		if (themeUrl && themeUrl.length > 0) {
			let url;
			const appUrl = getAppUrl();
			if (Util.isNullOrEmpty(getQueryStringValue("dev"))) {
				// url = `https://chat.satisfitest.us/Resources/ThemeFiles/${themeUrl}`;
				url = `${store.state.AWSServerURL}${store.state.AWSThemeFilePath}${themeUrl}`;
			} else {
				url = "./css/variables.css";
			}

			const request = new HttpRequest(url);
			let themeStyles: string = await request.sendGet(
				{},
				{
					Accept: "text/css",
				}
			);

			// Set the aws service full url here
			const awsFullURL = `${store.state.AWSServerURL}${store.state.AWSImageLogoPath}`;
			const bgImage = config.backgroundImage || "";

			// Set :root level css variables
			const newText = `\n:root {
                --botAvatar: url(${awsFullURL}${config.avatarBotImage});
                --associateAvatar: url(${awsFullURL}${config.avatarHumanImage});
                --headerLogoImage: url(${awsFullURL}${config.headerImage});
                --chatContainerBgImage: ${bgImage ? `url(${awsFullURL}${bgImage})` : `none`}
            }`;

			const style = document.createElement("style");
			style.innerHTML = themeStyles.concat(newText);
			style.id = "satisfi_theme";
			document.head.appendChild(style);

			// SD-13645: unify border widths between each button family's resting and hover
			// shorthands so hovering never resizes a button, whatever the theme data says.
			normalizeHoverBorders();

			// Store avatar URLs in Vuex state for use in chat display
			if (!Util.isNullOrEmpty(config.avatarBotImage == null ? "" : String(config.avatarBotImage))) {
				const aiAgentAvatarUrl = `${awsFullURL}${config.avatarBotImage}`;
				store.commit(STORE_MUTATION.SetAIAgentAvatarUrl, aiAgentAvatarUrl);
			} else {
				store.commit(STORE_MUTATION.SetAIAgentAvatarUrl, "");
			}

			if (!Util.isNullOrEmpty(config.avatarHumanImage == null ? "" : String(config.avatarHumanImage))) {
				const liveAgentAvatarUrl = `${awsFullURL}${config.avatarHumanImage}`;
				store.commit(STORE_MUTATION.SetLiveAgentAvatarUrl, liveAgentAvatarUrl);
			} else {
				store.commit(STORE_MUTATION.SetLiveAgentAvatarUrl, "");
			}

			console.log("SetIsConfigLoaded:true");
			store.commit(STORE_MUTATION.SetIsConfigLoaded, true);
		}
	}

	/**
	 * Updates the page configuration settings in the store based on provided configs.
	 * If configs is empty or not an object, the method will return without making any changes.
	 *
	 * @param configs - The configuration object containing page settings
	 * @returns void
	 */
	private updatePageConfig(configs: IConfig) {
		try {
			// Skip if the configs is not an object or is empty
			if (!configs || typeof configs !== "object" || Object.keys(configs).length === 0) {
				//console.warn("Invalid or empty configs provided.");
				return;
			}

			// Get the input placeholder text from the configs object, or use a default value if not present
			const placeholderText = configs.inputPlaceHolder || "";
			const maintainState = configs.maintainState || false;
			const convId = configs.convId || "";

			// Get the settings from the message
			let defaultSettings: IPageConfig = {
				inputContainerPlaceholderText: placeholderText,
				messageTimeFormat: DEFAULT_TIME_FORMAT,
				sendingIndicatorText: CONSTANTS.SENDING_MESSAGE, // This is a default value
				taglineText: CONSTANTS.POWERED_BY, // This is a default tagline text
			};

			// Check if maintain state is enabled,
			// if it is, then check if the page config is already saved in the local storage.
			// If it is, then use the saved page config settings.
			// If not, then update the store with the new page config settings.
			const settings = this.loadSettingsFromStorage(defaultSettings, convId, maintainState);

			// Log settings for debugging purposes
			//console.log("Loaded settings: ", settings);

			// Update the store with the config message settings
			store.commit(STORE_MUTATION.SetUpdatePageConfig, { payload: settings, maintainState });
		} catch (ex) {
			//onExceptionOccured("updatePageConfig", ex);
		}
	}

	/**
	 * Retrieves and merges saved settings from storage with default settings.
	 *
	 * @param defaultSettings - The default configuration settings to use as base
	 * @param convId - The conversation ID used to generate a unique storage key
	 * @param maintainState - Flag indicating whether to load saved settings or use defaults
	 * @returns A merged configuration object containing saved settings overlaid on defaults.
	 *          Returns defaultSettings if maintainState is false or if any error occurs.
	 *
	 * @remarks
	 * The method performs the following steps:
	 * 1. Returns default settings if maintainState is false
	 * 2. Retrieves saved config using the conversation ID
	 * 3. Validates and parses the saved config
	 * 4. Merges valid saved values with default settings
	 *
	 */
	private loadSettingsFromStorage(defaultSettings: IPageConfig, convId: string, maintainState: boolean): IPageConfig {
		try {
			// Input validation for the convId and maintainState arguments to ensure they are valid.
			if (!convId || typeof convId !== "string" || typeof maintainState !== "boolean" || !maintainState) {
				return defaultSettings;
			}

			const storageKey = this.getStorageKey(convId);
			const savedConfig = StorageHelper.get(storageKey);

			if (savedConfig && Util.isValidJSON(savedConfig)) {
				const parsedConfig = Util.validateAndParsePayload(savedConfig);
				if (parsedConfig) {
					// Merge parsedConfig with defaultSettings
					return Object.keys(defaultSettings).reduce(
						(updatedSettings, key) => {
							const payloadValue = parsedConfig[key as keyof IPageConfig];
							// Sanitize the payload value before updating the settings object
							const cleanValue = Util.sanitizeInput(payloadValue);
							if (!Util.isNullOrEmpty(cleanValue)) {
								updatedSettings[key as keyof IPageConfig] = cleanValue;
							}
							return updatedSettings;
						},
						{ ...defaultSettings }
					);
				}
			}
			return defaultSettings;
		} catch (ex) {
			//onExceptionOccured("loadSettingsFromStorage", ex);
			return defaultSettings;
		}
	}

	/**
	 * Generates a storage key for the given conversation ID.
	 * The key format is 'swc_pcfg_' followed by the conversation ID.
	 * @param convId - The conversation ID to create a storage key for
	 * @returns The generated storage key string, or empty string if an error occurs
	 * @throws {TypeError} If convId is not a string (handled internally)
	 */
	private getStorageKey(convId: string): string {
		try {
			// Create the storage key and value
			if (!convId || typeof convId !== "string") return; // skip if convId is not available
			const storageKey = `swc_pcfg_${convId}`;
			return storageKey;
		} catch (ex) {
			return "";
		}
	}

	/**
	 * SD-6795: Get the header image destination tracking URL based on the provided configs.
	 * If configs is empty or not an object, the method will return an empty string.
	 *
	 * @param configs - The configuration object containing page settings
	 * @param pageId - The page ID used to generate the tracking URL
	 * @returns The formatted header image destination tracking URL, or an empty string if an error occurs
	 */
	private getHeaderImageDestTrackingURL(configs: IConfig, pageId: string): string {
		try {
			// Skip if the configs is not an object or is empty
			if (!configs || typeof configs !== "object" || Object.keys(configs).length === 0) {
				//console.warn("Invalid or empty configs provided.");
				return "";
			}

			const companyId = configs.companyId || "";
			const headerImageDestinationURL = configs.headerImageDestinationURL || "";
			const headerImageTrackingConfig = configs.headerImageTrackingConfig || "";

			// SD-6795: Pre-format the header image destination tracking URL
			const formattedDestinationUrl = !Util.isNullOrEmpty(headerImageDestinationURL)
				? this.getFormattedDestinationUrl(headerImageDestinationURL, headerImageTrackingConfig, pageId, companyId)
				: "";

			const href = formattedDestinationUrl || headerImageDestinationURL;
			const headerImageDestTrackingURL = Util.trimString(href);
			return headerImageDestTrackingURL;
		} catch (ex) {
			//onExceptionOccured("updateHeaderImageDestTrackingURL", ex);
			return "";
		}
	}

	/**
	 * Formats the destination URL for the header image tracking.
	 *
	 * @param url - The destination URL to format
	 * @param headerImageTrackingConfig - The JSON string containing the tracking configuration
	 * @param pageId - The page ID used to generate the tracking URL
	 * @param companyId - The company ID used to generate the tracking URL
	 * @returns The formatted destination URL with tracking parameters, or an empty string if an error occurs
	 */
	private getFormattedDestinationUrl(
		url: string,
		headerImageTrackingConfig: string,
		pageId: string,
		companyId: string
	): string {
		try {
			// Validate that the input is a non-empty string
			if (!url || typeof url !== "string" || url.trim() === "") {
				return "";
			}

			// Trim whitespace and check if the resulting string is empty
			const trimmedUrl = url.trim();

			// Encode the URL to ensure it's safely included in the query parameters
			const encodedUrl = Util.sanitizeUrl(trimmedUrl);

			// Construct the formatted URL
			const config = this.getHeaderTrackingConfig(headerImageTrackingConfig);

			// Check if the tracking config is missing
			if (!config) {
				console.warn("No tracking config available.");
				return "";
			}

			const baseUrl = config.base_ebm_url || "";

			// Validate baseUrl before proceeding
			if (Util.isNullOrEmpty(baseUrl)) {
				console.warn("No base URL available.");
				return "";
			}

			// Check if url starts with or is included in base_ebm_url
			// as for some existing URLs, the url passed might already be a tracking URL
			if (trimmedUrl.startsWith(baseUrl) || trimmedUrl.includes(baseUrl)) {
				return url;
			}

			const params = new URLSearchParams({
				company_id: companyId || "",
				asset_id: pageId || "",
				asset_type_id: config.asset_type_id || "14",
				metadata_group: config.metadata_group || "url_click_tracking",
				metadata_key: config.metadata_key || "chat_page_header",
				url: encodedUrl,
			});

			return `${baseUrl}?${params.toString()}`;
		} catch (ex) {
			//onExceptionOccured("getFormattedDestinationUrl", ex);
			return "";
		}
	}

	/**
	 * Parses a JSON string into a TrackingConfig object.
	 *
	 * @param jsonString - The JSON string to parse
	 * @returns The parsed TrackingConfig object or null if parsing fails
	 */
	private parseJson(jsonString: string): ITrackingConfig | null {
		try {
			return JSON.parse(jsonString) as ITrackingConfig;
		} catch (ex) {
			//console.log("Embedder parseJson exception: " + ex);
			return null;
		}
	}

	/**
	 * Checks if the provided value is a valid non-empty string.
	 *
	 * @param value - The value to check
	 * @returns `true` if the value is a string and is not empty after trimming whitespace, `false` otherwise
	 */
	private isValidString(value: unknown) {
		try {
			return typeof value === "string" && value.trim() !== "";
		} catch (ex) {
			return false;
		}
	}

	/**
	 * Validates the tracking configuration.
	 *
	 * @param config - The tracking configuration to validate
	 * @returns `true` if the configuration is valid, `false` otherwise
	 *
	 * A valid configuration must:
	 * - Not be null
	 * - Have a valid base_ebm_url
	 * - Have at least one of the following properties valid:
	 *   - asset_type_id
	 *   - metadata_group
	 *   - metadata_key
	 */
	private validateConfig(config: ITrackingConfig | null): boolean {
		try {
			if (config === null) {
				return false;
			}

			const { base_ebm_url, asset_type_id, metadata_group, metadata_key } = config;

			// Check if base_ebm_url is valid
			if (!this.isValidString(base_ebm_url)) {
				return false;
			}

			// Check if at least one of the other properties is valid
			return (
				this.isValidString(asset_type_id) || this.isValidString(metadata_group) || this.isValidString(metadata_key)
			);
		} catch (ex) {
			return false;
		}
	}

	/**
	 * Parses and validates the JSON string to extract the header tracking configuration.
	 *
	 * @param jsonString - The JSON string to parse for tracking configuration.
	 * @returns The validated configuration object, empty object if valid but empty, or null if invalid.
	 */
	private getHeaderTrackingConfig(jsonString: string) {
		try {
			const config = this.parseJson(jsonString);
			if (!this.validateConfig(config)) {
				//console.error('Missing or invalid required properties');
				return null;
			}
			return config || {};
		} catch (ex) {
			//console.error("Error in createTrackingParams: " + ex);
			return null;
		}
	}

	/**
   * Parse a quoted, comma-separated string into a string array.
   *
   * Example:
   *  '"Unclear", "Incomplete", "Too long", "Correct, but not helpful"'
   *  => ["Unclear", "Incomplete", "Too long", "Correct, but not helpful"]
   *
   * @param input Raw string to parse
   * @returns Parsed string array (empty array if invalid)
   */
  /**
   * SD-13787: Start restoring a persisted admin session, when the page has admin mode on.
   *
   * Called right after the InitConfig dispatch: InitConfig commits the bot/page ids
   * synchronously before its first await, so they are in the store by the time this runs.
   * Deliberately not awaited - the restore is a server round-trip and nothing here needs it.
   * Everything that carries the adminMode flag awaits `ensureAdminModeRestored()` instead,
   * so the welcome message and the first user message no longer race it.
   */
  startAdminModeRestoreIfEnabled(configs: any) {
    try {
      if (configs && configs.enableAdminMode) {
        startAdminModeRestore();
      }
    } catch (ex) {
      console.log("[config_loader.ts] An error has occurred \n-> Inside startAdminModeRestoreIfEnabled -> Error: ", ex);
    }
  }

  private parseQuotedStringArray(input: string | null | undefined): string[] {
    try {
      if (!input || typeof input !== "string") return [];

      // Split by commas not inside quotes using regex
      const parts = input.match(/"([^"]*)"/g) ?? [];

      // Clean up each part: remove quotes, trim whitespace, filter empties
			return parts.map((item: string) => item.replace(/^"(.*)"$/, "$1").trim()).filter(Boolean);
    } catch (ex) {
      //console.error("Error in parseQuotedStringArray:", ex);
      return [];
    }
  }
}
